import { Component, Inject } from '@angular/core';
import { LoadingManager } from './managers/loading/loading.manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'CQ Webapp';

  constructor ( 
    public _loading: LoadingManager
  )  { }

}
